/** Mockup 01-C · Nenhum funil com captura. */
import React from 'react';

import { usePermissions } from '@/hooks/usePermissions';
import { Button, ModalContent, ModalFooter } from '@/shared/components/ui';
import { Icon } from '@/shared/icons';

export const CaptureEmptyState: React.FC<{ onClose: () => void; onConfigureFunnel?: (() => void) | undefined }> = ({ onClose, onConfigureFunnel }) => {
  const { hasModulePermission } = usePermissions();
  return (
    <>
      <ModalContent>
        <div className="text-center" style={{ padding: '14px 8px 10px' }} data-testid="capture-empty">
          <div className="w-[52px] h-[52px] rounded-[14px] mx-auto mb-3.5 flex items-center justify-center" style={{ background: '#f1f5f9', color: '#94a3b8' }}>
            <Icon name="qr-code" size={24} />
          </div>
          <div className="font-bold text-[15px] tracking-[-0.02em]" style={{ color: '#1e293b' }}>Nenhum funil com captura ativada</div>
          <p className="mx-auto mt-1.5 max-w-[360px] text-[13px] leading-[1.5]" style={{ color: '#64748b' }}>
            Para usar o QR Code, o gestor precisa ativar a <b>Captura</b> na configuração de um funil em que você atende (aba <b>Captura</b> do funil).
          </p>
        </div>
      </ModalContent>
      <ModalFooter>
        <span className="flex-1" />
        <Button variant="ghost" onClick={onClose} data-testid="capture-empty-close">Fechar</Button>
        {onConfigureFunnel && hasModulePermission('funnels', 'update') && (
          <Button variant="primary" icon="settings" onClick={onConfigureFunnel} data-testid="capture-empty-configure">Configurar funil</Button>
        )}
      </ModalFooter>
    </>
  );
};
